import axios from "axios"
import {appConfig} from "./../Config"
import {getTokenFromAzure} from "./common"

const httpService = (token = "") => {
    const baseURL = appConfig.gatewayAPIUrl

    const defaultOptions = async () => ({
        headers: {
            Authorization: `Bearer ${await getTokenFromAzure()}`,
            "Content-Type": "application/json",
        },
    })

    axios.interceptors.response.use(
        res => res,
        error => Promise.reject(error),
    )

    return {
        get: async (url, options = {}) => axios.get(baseURL + url, {...(await defaultOptions()), ...options}),
        post: async (url, data, options = {}) =>
            axios.post(baseURL + url, data, {...(await defaultOptions()), ...options}),
        put: async (url, data, options = {}) =>
            axios.put(baseURL + url, data, {...(await defaultOptions()), ...options}),
        delete: async (url, data, options = {}) =>
            axios.delete(baseURL + url, {...(await defaultOptions()), ...options}),
    }
}

export default httpService
